import { useState } from 'react';

const testimonials = [
  {
    quote: 'I have been using PandabuySpreadsheet for over six months now, and it completely transformed how I shop for streetwear. The curated lists save me hours of searching, and I have discovered so many incredible finds I would have never come across otherwise. The structured spreadsheet format makes comparing items across categories effortless.',
    author: 'Fashion Insider',
    role: 'Verified Shopper',
  },
  {
    quote: 'As someone new to agent shopping, PandabuySpreadsheet was a total game-changer. The beginner-friendly layout and clear category system helped me navigate the entire process without any confusion. Within my first week, I had already placed three orders using their curated shoe and accessories spreadsheets.',
    author: 'Style Curator',
    role: 'Verified Shopper',
  },
  {
    quote: 'The daily updates on PandabuySpreadsheet are honestly unmatched. Every morning I check the new drops, and I am always impressed by the quality of the curated selections. The hoodies and jackets categories in particular have some of the best spreadsheet finds I have seen anywhere online.',
    author: 'Trend Analyst',
    role: 'Verified Shopper',
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const goNext = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const goPrev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[40%] flex-shrink-0">
            <div className="rounded-[32px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20enthusiast%20standing%20in%20minimal%20white%20studio%20with%20warm%20terracotta%20accent%20wall%20holding%20smartphone%20showing%20shopping%20app%20casual%20contemporary%20style%20editorial%20portrait%20photography%20soft%20natural%20light%20from%20side%20window&width=600&height=800&seq=testim-2701-x3&orientation=portrait"
                alt="Verified PandabuySpreadsheet shopper testimonial"
                title="PandabuySpreadsheet Verified User Review"
                className="w-full h-[380px] md:h-[460px] object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center">
            <span className="text-xs font-medium text-foreground-400 tracking-wider uppercase">
              — Verified Shopper
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.12]">
              Real Reviews,
              <span className="block text-foreground-300">Real Style</span>
            </h2>

            <blockquote className="mt-10 text-base md:text-lg text-foreground-600 leading-relaxed italic border-l-2 border-primary-300 pl-6">
              &ldquo;{testimonials[current].quote}&rdquo;
            </blockquote>

            <p className="mt-6 text-base font-semibold text-foreground-950">
              &mdash; {testimonials[current].author}
            </p>

            <div className="mt-8 flex items-center gap-4">
              <button
                onClick={goPrev}
                className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:border-primary-400 hover:text-primary-500 transition-all cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={goNext}
                className="w-11 h-11 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-400 ml-1">
                {current + 1} / {testimonials.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}